<template>
  <swiper
    :ref="sliderRef"
    :options="options"
    :class="customClass"
    class="slider"
  >
    <slot />
  </swiper>
</template>

<script>
import { Swiper /*, SwiperSlide */ } from "vue-awesome-swiper";

export default {
  components: {
    Swiper,
    // SwiperSlide,
  },
  props: {
    sliderRef: {
      type: String,
      default: null,
    },

    options: {
      type: Object,
      default: null,
    },

    customClass: {
      type: String,
      default: null,
    },

    buttons: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.slider {
  &-buttons {
    position: absolute;
    right: 2rem;
    top: 0;
  }
}
</style>
